import { auroraHub } from 'vuetify-aurora';

const odataConf = {
  getConf: rootState => ({
    headers: new Headers({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${rootState.aurora.auth.access_token}`,
    }),
    onStart: () => {
      auroraHub.$emit('before-request', 'odata');
    },
    onFinish: () => {
      auroraHub.$emit('after-response', 'odata');
    },
    onError: (x, e) => {
      if (e.status === 401) {
        auroraHub.$emit('user.unauthorized');
      }
      auroraHub.$emit('after-response', 'odata');
      auroraHub.$emit('request-error');
    },
  }),
  parseId: (id) => {
    let i = id;
    if (Number.isNaN(id)) {
      i = `'${id}'`;
    }
    return i;
  },
};
export { odataConf };

export default {};
